import { useMutation, useQuery } from '@apollo/client';
import { useParams } from 'react-router';

import {
  CompanyLemLicensesQuery,
  CompanyLemLicensesQueryVariables,
  GrantCompanyLemLicenseMutation,
  GrantCompanyLemLicenseMutationVariables,
  RevokeCompanyLemLicenseMutation,
  RevokeCompanyLemLicenseMutationVariables,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CompanyLemView, CompanyLemViewProps } from '../components/company_lem';
import { companyLemLicensesQuery, grantCompanyLemLicenseMutation, revokeCompanyLemLicenseMutation } from '../graphql';

class LoadingContainer extends Loader<CompanyLemLicensesQuery, CompanyLemViewProps, CompanyLemLicensesQueryVariables> {}

export const CompanyLemContainer = () => {
  const { company_id: companyId } = useParams() as { company_id: string };

  const result = useQuery<CompanyLemLicensesQuery, CompanyLemLicensesQueryVariables>(companyLemLicensesQuery, {
    variables: { company_id: companyId },
    fetchPolicy: 'cache-and-network',
  });

  const [grantMutate] = useMutation<GrantCompanyLemLicenseMutation, GrantCompanyLemLicenseMutationVariables>(
    grantCompanyLemLicenseMutation,
  );
  const [revokeMutate] = useMutation<RevokeCompanyLemLicenseMutation, RevokeCompanyLemLicenseMutationVariables>(
    revokeCompanyLemLicenseMutation,
  );

  const refetch = [
    {
      query: companyLemLicensesQuery,
      variables: { company_id: companyId },
    },
  ];

  return (
    <LoadingContainer
      result={result}
      mapData={({ data }) => {
        const view = data.companyLemLicenses;
        if (view === null || view === undefined) {
          throw new Error('Backend returned no LEM license view for this company');
        }
        return {
          data: view,
          onGrant: async () => {
            await grantMutate({
              variables: { company_id: companyId },
              refetchQueries: refetch,
              awaitRefetchQueries: true,
            });
          },
          onRevoke: async () => {
            await revokeMutate({
              variables: { company_id: companyId },
              refetchQueries: refetch,
              awaitRefetchQueries: true,
            });
          },
        };
      }}>
      {({ data, onGrant, onRevoke }) => <CompanyLemView data={data} onGrant={onGrant} onRevoke={onRevoke} />}
    </LoadingContainer>
  );
};
